import React from 'react';
import './CarModelCircularProgress.scss';

const CarModelCircularProgress = ({
  progress,
  size = 100,
  strokeWidth = 10,
  circleColor = 'transparent',
  progressColor = '#898989',
  children,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className={'car-model-interactive-progress-block'}>
      <div className={'container-progress'} style={{ width: size, height: size }}>
        <svg width={size} height={size} className={'svg'} style={{ transform: 'rotate(-90deg)' }}>
          <circle
            className={'circleBackground'}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            fill="none"
            style={{ stroke: circleColor }}
          />
          <circle
            className={'circleProgress'}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            fill="none"
            style={{
              stroke: progressColor,
              strokeDasharray: circumference,
              strokeDashoffset: offset,
              transition: 'stroke-dashoffset 0.35s ease',
            }}
          />
        </svg>
        <div className={'content-progress'}>{children}</div>
      </div>
    </div>
  );
};

export default CarModelCircularProgress;
